import { DeleteOutline } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const FilePreview = ({
  file,
  handleDeleteFile,
}: {
  file: {
    filename: string;
    id: string;
    data: Blob;
  };
  handleDeleteFile: () => void;
}) => {
  const fileSize = file.data.size;
  const isImage = file.data.type.startsWith("image/");

  return (
    <div
      key={`${file.id}`}
      className="flex items-center justify-between p-3 border rounded-lg border-gray-200 border-solid border-1"
    >
      <div className="flex items-center gap-3">
        {isImage ? (
          <img
            src={URL.createObjectURL(file.data)}
            alt={file.filename}
            className="w-8 h-8 object-cover rounded border"
          />
        ) : (
          <span>📄</span>
        )}
        <div className="flex flex-col">
          <Typography variant="body2" className="font-medium">
            {file.filename}
          </Typography>
          <Typography variant="caption" className="text-gray-500">
            {formatFileSize(fileSize)}
          </Typography>
        </div>
      </div>
      <IconButton size="small" onClick={handleDeleteFile}>
        <DeleteOutline fontSize="small" />
      </IconButton>
    </div>
  );
};
